const Columns = [
  {
    id: "createdOn",
    numeric: false,
    disablePadding: false,
    label: "Date",
    isSortable: true,
    gray: true
  },
  {
    id: "recipient",
    numeric: false,
    disablePadding: false,
    label: "Recipient",
    isSortable: true,
    gray: true
  },
  {
    id: "Type",
    numeric: false,
    disablePadding: false,
    label: "Method",
    isSortable: true,
    gray: true
  },
  {
    id: "Message",
    numeric: false,
    disablePadding: false,
    label: "Notification Message",
    isSortable: true,
    gray: true
  },
  {
    id: "action",
    numeric: false,
    disablePadding: true,
    label: "Action",
    gray: true
  },
];

export { Columns };